import { render, staticRenderFns } from "./batchIncome.vue?vue&type=template&id=05009036&scoped=true"
import script from "./batchIncome.vue?vue&type=script&lang=js"
export * from "./batchIncome.vue?vue&type=script&lang=js"
import style0 from "./batchIncome.vue?vue&type=style&index=0&id=05009036&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05009036",
  null
  
)

export default component.exports